import React from 'react';
import { useState } from 'react';
import ProgressBar from './ProgressBar';


const UploadForm = () => {
    const [file, setFile] = useState(null);
    const [error, setError] = useState(null);

    const types = ['image/png', 'image/jpeg', 'image/jpg'];

    const changeHandler = (e) => {
        let selected = e.target.files[0];

        if (selected && types.includes(selected.type)) {
            setFile(selected);
            setError(null);
        }else{
            setFile(null);
            setError('Please select an image file');

        }
    }

    return (
        <form>
            <label className="upload-btn">
                
                <input type="file" onChange={changeHandler} />
                
                <span
                    // style={{ 
                    // display: "block",
                    // width: "30px",
                    // height:" 30px",
                    // border: "1px solid var(--primary)",
                    // borderRadius:" 50%",
                    // margin: "10px auto",
                    // lineHeight: "30px",
                    // color: "var(--primary)",
                    // fontWeight: "bold",
                    // fontSize: "24px",
                    // }}
                    >+</span> 
                
            </label>
            <div className="output">
                {error && <div className="error">{ error }</div>}
                { file && <div>{ file.name }</div>}
                { file && <ProgressBar file={file} setFile={setFile} />}
            </div>
        </form>
    )
}

export default UploadForm;